import React, { forwardRef } from "react";

const ConfettiEffect = forwardRef<HTMLDivElement>((props, ref) => {
  return <div ref={ref} className="absolute inset-0 pointer-events-none"></div>;
});

export default ConfettiEffect;
